export const trackCarrier = (addedCartItem, parentItem) => {
    // Merging Parent SKU and Carrier SKU into single object for tracking
    const { brand, insightPartId, materialID, name, price, categoryType } = addedCartItem;
    const parentSKU = {
        name: parentItem.description,
        id: parentItem.materialID,
        productSku: parentItem.mfrPartNumber,
        insightPartId: parentItem.materialID,
        price: parentItem.price,
        brand: parentItem.manufacturerName,
        category: parentItem.categoryId,
        quantity: parentItem.quantity,
        currency: parentItem.currency,
    }
    const carriersInfo = {
        carrierName: name,
        carrierProductSku: materialID || insightPartId,
        carrierInsightPartId: insightPartId,
        carrierPrice: price,
        carrierBrand: brand,
        carrierCategoryType: 'Carrier Activation',
        carrierServiceType: brand,
        categoryType: categoryType
    }
    return {
        ...parentSKU,
        ...carriersInfo,
    }
}